<template>
  <div class="app">
    <header>
      <div class="header-row">
        <h3 class="app-title" @click="moveToTop">BiZOOPe Portal</h3>
      </div>
      <div class="header-row">
        <div>
          <h3 class="md-title">{{ subTitle }}</h3>
        </div>
        <div class="section-end">
          <router-link to="/announcement">
            <md-badge
              class="md-square"
              md-content="New"
              v-if="hasUnread"
            >
              <md-button
                style="color: #fff"
                class="md-icon-button"
                title="お知らせ"
              >
                <font-awesome-icon icon="bell"/>
              </md-button>
            </md-badge>
            <md-button
              v-else
              style="color: #fff"
              class="md-icon-button"
              title="お知らせ"
             >
               <font-awesome-icon icon="bell"/>
            </md-button>
          </router-link>

          <router-link to="/preferences">
            <md-button
              style="color: #fff"
              v-if="!requiresPasswordChange"
              class="md-icon-button"
              title="個人設定"
            >
              <font-awesome-icon icon="cog"/>
            </md-button>
          </router-link>
          <router-link to="/users">
            <md-button
              style="color: #fff"
              v-if="!requiresPasswordChange && isAdmin"
              class="md-icon-button"
              title="ユーザー一覧"
            >
              <font-awesome-icon icon="users"/>
            </md-button>
          </router-link>
          <md-button
            style="color: #fff"
            @click="logout"
            class="md-icon-button"
            title="ログアウト"
          >
            <font-awesome-icon icon="sign-out-alt"/>
          </md-button>
        </div>
      </div>
    </header>
    <main>
    <slot></slot>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasUnread: false,
    }
  },
  computed: {
    subTitle() {
      return this.$store.state.currentPage.title
    },
    isAdmin() {
      return this.$store.state.user.isAdmin
    },
    requiresPasswordChange() {
      return this.$store.state.user.requiresPasswordChange
    },
  },
  async created() {
    await this.$service.getServices()
    const repo = this.$announcement
    const announcements = await repo.get()
    if (announcements.length === 0) {
      return
    }
    const latest = announcements[0].id
    const lastRead = await repo.getLastRead()
    if (!lastRead) {
      this.hasUnread = true
    } else {
      this.hasUnread = latest > lastRead
    }
  },
  methods: {
    moveToTop() {
      this.$router.push('/')
    },
    async logout() {
      await this.$store.dispatch('logout')
      this.$router.push('/login')
    },
  },
}
</script>


<style lang="scss" scoped>
header {
  background: var(--md-theme-default-primary, #448aff);
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100; // force top

  .app-title {
    cursor: pointer;
  }
}

.header-row {
  align-items: center;
  display: flex;
  height: 56px;
  margin-left: 24px;
  margin-right: 24px;

  .section-end {
    display: flex;
    justify-content: flex-end;
    flex: 1;
  }
}

main {
  padding-top: calc(56px * 2);
}
</style>
